const BASE_URL = 'https://apis.consultasruc.com:4000';
const BASE_URL_2 = 'https://apis.paleconsultores.com/v2';
//https://apis.paleconsultores.com/v2/ConsultaRuc/?RUC=20491228297&TOKEN=484848
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const randomNumber = (min = 0, max = 1) => Math.floor(Math.random() * (max - min + 1)) + min;

const simulateNetworkLatency = (min = 30, max = 1500) => delay(randomNumber(min, max));

async function callApi(endpoint, options = {}) {
  await simulateNetworkLatency();

  // eslint-disable-next-line no-param-reassign
  options.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  const url = BASE_URL + endpoint;
  const response = await fetch(url, options);
  const data = await response.json();

  return data;
}

async function llamarApi(endpoint, options = {}) {
  await simulateNetworkLatency();

  options.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  const url2 = BASE_URL_2 + endpoint;
  const response = await fetch(url2, options);
  const data = await response.json();

  return data;
}

const api = {
  usuario: {
    enviarCorreoVentas(datos) {
      return llamarApi('/api/mails/ifacturacion', { // enviar correo de infor palerp los datos de la persona que son nombre,correo mensaje
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    enviarCorreoRegistro(datos) {
      return llamarApi('/api/mails/ifacturacionRegistro', { // enviar correo de infor palerp los datos de la persona que son nombre,correo mensaje
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    enviarCorreoEncuesta(mailCliente,incidencia, mensaje) {

      const datos = {
        "Token": "484848",
        "Operacion": "",
        "Conexion": {
          "BaseDeDatos": "",
          "Procedimiento": ""
        },
        "Parametros": [
          `paleconsultores@gmail.com , ${mailCliente}`, //destinatario, pueden ser varios entre comas
          "PALE ENCUESTAS", //cabecera
          "Encuesta Nro: " + incidencia, //asunto
          mensaje //mensaje puede contener saltos de linea negritas (formato html)
        ],
        "Adjuntos": [
        ]
      }

      return llamarApi(`/Mail/post/`, {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    }
  },
  DescargaComprobante: {
    descargarPDF(datos) {
      return callApi('/api/AArchivo/comprobantespdf', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    DownloadArchivoXmlCdr(encript) {
      return callApi(`/api/AArchivo/url/${encript}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
  },
  SubidaArchivos: {
    subirArchivos(datos) {
      return callApi('/api/AArchivo/subidaArchivo', {
        enctype: 'multipart/form-data',
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    listarArchivos() {
      return callApi('/api/AArchivo/listarArchivos');
    }
  },
  EmpresaObligada: {
    consultarEmpresa(ruc) {
      return callApi(`/api/AEmpresaObligada/${ruc}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
  },
  libroReclamaciones: {
    guardarReclamo(datos) {
      return callApi('/api/AIncidentes/save', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    traerNroIncidencia(datos) {
      return callApi('/api/AIncidentes/listarUno', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    creacionPDF(datos) {
      return callApi('/api/mails/createPDFNuevo', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    enviarEmail(datos) {
      return callApi('/api/mails/emailCliente', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    }
  },
  clienteProveedor: {
    guardarClienteProvedor(datos) {
      return callApi('/api/AIncidentes/save/cliente-Proveedor', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
  },
  ConsultaRuc: {
    consultarRUC(ruc) {
      return callApi(`ConsultaRuc/?RUC=${ruc}&TOKEN=484848`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  },
  IncidenciaCliente: {
    traerIncidencia(id) {
      const datos = {
        "Token": "484848",
        "Operacion": "1",
        "Conexion": {
          "BaseDeDatos": "master",
          "Procedimiento": "USP_SOP_INCIDENCIAS_TXPK"
        },
        "Parametros": [
          id
        ]
      };

      return llamarApi('/basico', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    traerCliente(id) {
      const datos = {
        "Token": "484848",
        "Operacion": "1",
        "Conexion": {
          "BaseDeDatos": "master",
          "Procedimiento": "USP_SOP_CLIENTES_TXPK"
        },
        "Parametros": [
          String(id)
        ]
      };

      return llamarApi('/basico', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    guardarIncidencia(incidencia, pregunta1, pregunta2, pregunta3, estado, usuario) {
      const datos = {
        "Token": "484848",
        "Operacion": "1",
        "Conexion": {
          "BaseDeDatos": "master",
          "Procedimiento": "USP_SOP_INCIDENCIAS_G_Encuesta"
        },
        "Parametros": [
          String(incidencia),
          String(pregunta1),
          String(pregunta2),
          String(pregunta3),
          String(estado),
          String(usuario)
        ]
      };
      return llamarApi('/basico', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
    guardarIncidenciaNoResuelta(incidencia, observacion, usuario) {
      const datos = {
        "Token": "484848",
        "Operacion": "1",
        "Conexion": {
          "BaseDeDatos": "master",
          "Procedimiento": "USP_SOP_INCIDENCIAS_G_NORESUELTA"
        },
        "Parametros": [
          String(incidencia),
          String(observacion),
          String(usuario)
        ]
      };
      return llamarApi('/basico', {
        method: 'POST',
        body: JSON.stringify(datos),
      });
    },
  },
};

export default api;
